import SideBarButton from "./SideBarButton";
import { navigateTo } from "context/navigation.service";
import { useDataStore } from "@store/user_org";
import { isGUEST } from "@helpers/accessHelpers";

export default function SettingBar({
  page,
  setPage,
}: {
  page: string;
  setPage: (page: string) => void;
}) {
  const userData = useDataStore((state) => state.userData);
  const isGuest = isGUEST(userData);

  return (
    <div className="w-64 min-w-64 h-screen justify-start pt-10 pl-2 border-r-1 flex flex-col">
      <div className="flex flex-col pl-2">
        <div className="ml-3 font-semibold text-hx">Paramètres</div>
        <div className="flex flex-col mt-6 mr-6">
          <SideBarButton
            label="Compte"
            name="user"
            highlighted={page === "account"}
            onClick={() => navigateTo({ route: "/settings?page=account" })}
          />
          {!isGuest && (
            <>
              <SideBarButton
                label="Entreprise"
                name="business"
                highlighted={page === "company"}
                onClick={() => navigateTo({ route: "/settings?page=company" })}
              />
              <SideBarButton
                label="Equipe"
                name="users"
                highlighted={page === "team"}
                onClick={() => navigateTo({ route: "/settings?page=team" })}
              />
              <SideBarButton
                label="Disponibilités"
                name="sett-dispo"
                highlighted={page === "disponibilites"}
                onClick={() =>
                  navigateTo({ route: "/settings?page=disponibilites" })
                }
              />
              <SideBarButton
                label="Service rapide"
                name="sett-fast"
                highlighted={page === "service-rapide"}
                onClick={() =>
                  navigateTo({ route: "/settings?page=service-rapide" })
                }
              />
              <SideBarButton
                label="Prise de RDV"
                name="sett-rdv"
                highlighted={page === "prise-rdv"}
                onClick={() =>
                  navigateTo({ route: "/settings?page=prise-rdv" })
                }
              />
              <SideBarButton
                label="Interventions"
                name="sett-interventions"
                highlighted={page === "interventions"}
                onClick={() =>
                  navigateTo({ route: "/settings?page=interventions" })
                }
              />
              <SideBarButton
                label="Avis clients"
                name="star"
                highlighted={page === "avis"}
                onClick={() =>
                  navigateTo({ route: "/settings?page=avis" })
                }
              />
              <SideBarButton
                label="Signatures"
                name="sett-sign"
                highlighted={page === "signatures"}
                onClick={() =>
                  navigateTo({ route: "/settings?page=signatures" })
                }
              />
              <SideBarButton
                label="Paiements"
                name="sett-payments"
                highlighted={page === "paiements"}
                onClick={() =>
                  navigateTo({ route: "/settings?page=paiements" })
                }
              />
              <SideBarButton
                label="Surcharge"
                name="facture"
                highlighted={page === "surcharge"}
                onClick={() =>
                  navigateTo({ route: "/settings?page=surcharge" })
                }
              />
              <SideBarButton
                label="Notifications"
                name="cloche"
                highlighted={page === "notifications"}
                onClick={() =>
                  navigateTo({ route: "/settings?page=notifications" })
                }
              />
              <SideBarButton
                label="ServiceBox"
                name="sett-servicebox"
                highlighted={page === "servicebox"}
                onClick={() =>
                  navigateTo({ route: "/settings?page=servicebox" })
                }
              />
              <SideBarButton
                label="WhatsApp"
                name="message"
                highlighted={page === "whatsapp"}
                onClick={() =>
                  navigateTo({ route: "/settings?page=whatsapp" })
                }
              />
              <SideBarButton
                label="Modèles emails"
                name="email"
                highlighted={page === "email-templates"}
                onClick={() =>
                  navigateTo({ route: "/settings?page=email-templates" })
                }
              />
            </>
          )}
        </div>
      </div>
    </div>
  );
}
